module.exports = __webpack_public_path__ + "static/media/lucia_spanish_castilian.c718552c.mp3";